// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { CheckboxTokens } from './type';

const checkboxTokens: CheckboxTokens = {
  checkboxIconSize: 'Size-7',
  checkboxIconBorderColor: 'Neutral-border-2',
  checkboxIconBorderRadius: 'Radius-2',
  checkboxIconBorderWidth: 'Border-1',
  checkboxIconBackgroundColor: 'Neutral-fill-1',
  checkboxIconColor: 'transparent',
  checkboxIconDisabledBorderColor: 'Neutral-border-1',
  checkboxIconDisabledBackgroundColor: 'Neutral-fill-2',
  checkboxIconDisabledColor: 'transparent',
  checkboxIconHoverBackgroundColor: 'Neutral-fill-1',
  checkboxIconHoverColor: 'transparent',
  checkboxIconCheckedBorderColor: 'Brand-6',
  checkboxIconCheckedBackgroundColor: 'Brand-6',
  checkboxIconCheckedColor: 'Neutral-fill-1',
  checkboxIconCheckedDisabledBorderColor: 'Brand-3',
  checkboxIconCheckedDisabledBackgroundColor: 'Brand-3',
  checkboxIconCheckedDisabledColor: 'Neutral-fill-1',
  checkboxIconGap: 'Margin-8',
  checkboxIconCircleFill: 'Neutral-fill-2',
  checkboxIconCircleDark: 'Neutral-fill-3',
  checkboxLabelFontColor: 'Neutral-text-5',
  checkboxLabelFontSize: '14/regular',
  checkboxLabelDisabledFontColor: 'Neutral-text-2',
  checkboxGap: 'Margin-24',
  checkboxBlockGap: 'Margin-12',
  checkboxSmallIconSize: 'Size-6',
  checkboxSmallLabelFontSize: '12/regular',
  checkboxLargeIconSize: 'Size-8',
  checkboxLargeLabelFontSize: '16/regular',
};

export default checkboxTokens;
